<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <v-btn
              depressed
              class="mx-2"
              icon
              text
              small
              :to="{ name: 'conta-bancaria-list', path: 'lista' }"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span v-if="tituloNovo">Nova conta bancária</span>
              <span v-else>Alterar conta bancária: {{ descricao }}</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-text-field
              v-model="descricao"
              :error-messages="descricaoErrors"
              :counter="50"
              label="Descrição"
              required
              @input="$v.descricao.$touch()"
              @blur="$v.descricao.$touch()"
            ></v-text-field>
            <v-select
              v-model="id_empresa"
              label="Empresa"
              :items="empresas"
              item-text="nome_fantasia"
              item-value="id"
            />
            <v-text-field
              v-model="agencia"
              :error-messages="agenciaErrors"
              :counter="10"
              label="Agência"
              required
              @input="$v.agencia.$touch()"
              @blur="$v.agencia.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="conta"
              :error-messages="contaErrors"
              :counter="10"
              label="Conta"
              required
              @input="$v.conta.$touch()"
              @blur="$v.conta.$touch()"
            ></v-text-field>
            <v-autocomplete
              v-model="select"
              :items="items"
              item-value="id"
              :filter="filtrarBancos"
              hide-no-data
              label="Banco"
              clearable
            >
              <template v-slot:item="{ item }">{{ item.codigo }} - {{ item.nome }}</template>
              <template v-slot:selection="{ item }">{{ item.codigo }} - {{ item.nome }}</template>
            </v-autocomplete>
            <v-autocomplete
              v-model="ids_forma_pagamento"
              chips
              :items="formasPgto"
              multiple
              item-text="descricao"
              item-value="id"
              label="Formas de pagamento"
              deletable-chips
              eager
            />
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    descricao: { required, maxLength: maxLength(50) },
    agencia: { required, maxLength: maxLength(10) },
    conta: { required, maxLength: maxLength(10) }
  },

  data() {
    return {
      id: "",
      id_empresa: this.$store.state.usuarios.empresaAtiva.id,
      descricao: "",
      agencia: "",
      conta: "",
      preloader: false,
      tituloNovo: true,
      ids_forma_pagamento: [],
      loading: false,
      items: [],
      search: null,
      select: null
    };
  },

  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.maxLength && errors.push("Somente 50 caracteres.");
      !this.$v.descricao.required && errors.push("Descrição é Obrigatório.");
      return errors;
    },
    agenciaErrors() {
      const errors = [];
      if (!this.$v.agencia.$dirty) return errors;
      !this.$v.agencia.maxLength && errors.push("Somente 10 caracteres.");
      //!this.$v.agencia.numeric && errors.push("Somente número");
      !this.$v.agencia.required && errors.push("Agência é Obrigatório.");
      return errors;
    },
    contaErrors() {
      const errors = [];
      if (!this.$v.conta.$dirty) return errors;
      !this.$v.conta.maxLength && errors.push("Somente 10 caracteres.");
      //!this.$v.conta.numeric && errors.push("Somente número");
      !this.$v.conta.required && errors.push("Conta é Obrigatório.");
      return errors;
    },
    ...mapState({
      formasPgto: state => state.formaPgto.formasPagamentos,
      empresas: state => state.empresa.empresas
    })
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    }
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;

        const success = await this.$store.dispatch("contaBancaria/gravar", {
          id: this.id,
          id_empresa: this.id_empresa,
          descricao: this.descricao,
          agencia: this.agencia,
          conta: this.conta,
          id_banco: this.select,
          ids_forma_pagamento: this.ids_forma_pagamento
        });
        this.loading = false;
        if (success) {
          this.$router.replace({ path: "lista", name: "conta-bancaria-list" });
        }
      }
    },
    filtrarBancos(item, queryText) {
      const filtro = queryText
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      const nome = item.nome
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      return nome.indexOf(filtro) > -1 || item.codigo.indexOf(filtro) > -1;
    }
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de contas bancárias"
    });

    this.$store.dispatch("empresa/listar");

    this.loading = true;
    this.id = "";
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch(
          "contaBancaria/carregarContaBancaria",
          id
        );
        this.id_empresa = response.data.id_empresa;
        this.descricao = response.data.descricao;
        this.agencia = response.data.agencia;
        this.conta = response.data.conta;
        this.select = response.data.id_banco;
        this.ids_forma_pagamento = response.data.ids_forma_pagamento;
      } catch (err) {
        //deu pau
      }
    }

    var aBancos = await this.$store.dispatch("contaBancaria/carregarBancos");
    this.items = aBancos.data;

    await this.$store.dispatch("formaPgto/listar", {});

    this.loading = false;
  }
};
</script>
